import { createContext } from "react";
const VideoBannerContext = createContext({});
export default VideoBannerContext;
